<template>
    <section class="assessmentSection checkoutSection">
        <div class="checkoutContainer">
            <CheckoutHeader current-page="Payment Info" />
            <div class="checkoutBody">
                <div class="checkoutOverview checkoutPaymentOverview">
                    <h2 class="checkoutTitle">Choose your payment method</h2>

                    <div class="checkoutPaymentOptions">
                        <!-- PAYMENT OPTION -->
                        <div class="checkoutPaymentOption"
                             :class="{'selected': paymentMethod === 'PayPal'}"
                             @click="selectMethod('PayPal')">
                            <div class="checkoutPaymentOption-title">
                                <div class="checkoutPaymentOption-selector"></div>
                                <span>PayPal</span>
                                <img class="checkoutPaymentOption-image"
                                     src="/img/paypal-logo.png"
                                     alt="PayPal Logo" />
                            </div>
                            <div class="checkoutPaymentOption-description">
                                Pay for your system with PayPal’s secure online platform
                            </div>
                            <transition name="fade">
                                <div v-show="paymentMethod === 'PayPal'"
                                     class="creditCardForm">
                                    <div id="paypal-button"></div>
                                </div>
                            </transition>
                        </div>
                        <!-- END PAYMENT OPTION -->

                        <!-- PAYMENT OPTION -->
                        <div class="checkoutPaymentOption"
                             :class="{'selected': paymentMethod === 'Credit Card'}"
                             @click="selectMethod('Credit Card')">
                            <div class="checkoutPaymentOption-title">
                                <div class="checkoutPaymentOption-selector"></div>
                                <span>Credit Card</span>
                                <img class="checkoutPaymentOption-image"
                                     src="/img/credit-card-logos.png"
                                     alt="Credit Card Logo" />
                            </div>
                            <div class="checkoutPaymentOption-description">
                                Safe and Secure online money transfer using your bank account. Visa, Mastercard, Discover, and American Express
                            </div>

                            <div v-show="paymentMethod === 'Credit Card'"
                                 class="creditCardForm outlined">
                                <div id="card-element"></div>
                            </div>
                        </div>
                        <!-- END PAYMENT OPTION -->
                    </div>

                    <transition name="fade">
                        <button v-if="paymentMethodIsCreditCard"
                                class="button"
                                :disabled="completeDisabled"
                                @click="getStripeToken">
                            Complete Order
                        </button>
                    </transition>

                </div>
                <CheckoutSummary />
            </div>
        </div>
    </section>
</template>


<script>
import { mapActions, mapState } from 'vuex'
import CheckoutHeader from './CheckoutHeader.vue'
import CheckoutSummary from './CheckoutSummary.vue'
import CheckoutMonitoringPayment from './CheckoutMonitoringPayment.vue'
import VueGoogleAutocomplete from 'vue-google-autocomplete'
import Vue from 'vue'
export default {
    data() {
        return {
            card: {},
            paypalInitialized: false,
            completeDisabled: false,
        }
    },
    computed: {
        ...mapState(['lead', 'system']),

        paymentMethod() {
            return this.system.paymentMethod
        },

        paymentMethodIsPayPal() {
            return this.paymentMethod === 'PayPal'
        },

        paymentMethodIsCreditCard() {
            return this.paymentMethod === 'Credit Card'
        },

        paymentMethodFilled() {
            return this.cc && this.cvv && this.ccExp && this.ccName
        },

        monitoringPaymentMethodFilled() {
            return (
                this.monitoringCc &&
                this.monitoringCvv &&
                this.monitoringCcExp &&
                this.monitoringCcName
            )
        },

        monitoringPaymentMethodVisible() {
            if (this.paymentMethodIsCreditCard) {
                return this.paymentMethodFilled
            }

            if (this.paymentMethodIsPayPal) {
                return true
            }

            return false
        },

        ccNumberMask() {
            if (this.cc.substr(0, 1) == 3) {
                return '#### ###### #####'
            }
            return '#### #### #### ####'
        },

        cvvMask() {
            if (this.cc.substr(0, 1) == 3) {
                return '####'
            }
            return '###'
        },

        ccExpMask() {
            return '##/##'
        },

        readyToContinue() {
            let name = this.lead.name
            let email = this.lead.email
            let phone = this.lead.phone
            let address = this.place

            if (name && email && phone && address) {
                return true
            }

            return true
        }
    },
    methods: {
        ...mapActions(['selectPaymentMethod', 'updateOrder', 'updateSystem']),

        selectMethod(method) {
            this.selectPaymentMethod(method)
            Vue.nextTick(() => {
                this.initPaypal()
            })
        },

        selectMonitoringPaymentMethod(method) {
            this.monitoringPaymentMethod = method
        },

        processOrder(params) {
            let that = this
            let data = {
                lead: this.lead,
                system: this.system,
                token: params.token,
                paymentMethod: this.system.paymentMethod,
                paymentData: params.paymentData
            }

            this.completeDisabled = true

            let request = axios
                .post('/ajax/orders/create', data)
                .then(res => {
                    let order = res.data
                    that.updateOrder(order)
                    mixpanel.track("completedOrder")
                    mixpanel.people.set({
                        "install code": order.uuid,
                        "order total": order.total
                    })

                    const city = this.lead.place.address_components.filter(c => c.types.includes('locality'))[0].long_name
                    const state = this.lead.place.address_components.filter(c => c.types.includes('administrative_area_level_1'))[0].long_name
                    const zip = this.lead.place.address_components.filter(c => c.types.includes('postal_code'))[0].long_name
                    // Essential
                    let ee = this.system.essential.map(e => e.name)
                    // Additional
                    let ea = this.system.additional.map(e => e.name)
                    // All equipment
                    let ae = ee.concat(ea)

                    Intercom('trackEvent', 'completedOrder', {
                        "install code": order.uuid,
                        "order total": order.total,
                        name: this.lead.name,
                        email: this.lead.email,
                        phone: this.lead.phone,
                        equipmentList: ae.join(', '),
                        address: this.lead.place.formatted_address,
                        city: city,
                        state: state,
                        zip: zip,
                    });

                    gtag('event', 'purchase', {
                        "transaction_id": order.uuid,
                        "affiliation": "True Security - Website",
                        "value": order.total,
                        "currency": "USD",
                        "tax": 0,
                        "shipping": 0,
                        "items": [],
                    })

                    that.$router.push(`/assessment/complete?confirmation=${order.uuid}`)
                })
                .catch(error => {
                    console.log(error)
                    alert('There was an error processing your order')
                    this.completeDisabled = false
                })
        },

        getStripeToken() {
            let that = this
            stripe.createToken(this.card).then(function(result) {
                if (result.error) {
                    // Inform the customer that there was an error
                    var errorElement = document.getElementById('card-errors')
                    errorElement.textContent = result.error.message
                } else {
                    // Send the token to your server
                    that.processOrder({
                        token: result.token,
                        paymentData: ''
                    })
                }
            })
        },

        initPaypal() {
            if (this.paypalInitialized) {
                return
            }
            let that = this
            /**
             * PayPal Integration
             */
            paypal.Button.render({
                    env: 'sandbox', // Or 'sandbox', production
                    client: {
                        sandbox: 'Aa_G49xzE6XqjUrO0m0Jn1F56cQQnwn0lxhc_zunwIdOxE9n4TK-13w_G5aV68w_kRzE2NuFGW2IxrsS',
                        production: ''
                    },
                    commit: true, // Show a 'Pay Now' button
                    payment: function(data, actions) {
                        return actions.payment.create({
                            payment: {
                                transactions: [{
                                    amount: {
                                        total: that.system.discountedTotal,
                                        currency: 'USD'
                                    }
                                }]
                            }
                        })
                    },

                    onAuthorize: function(data, actions) {
                        return actions.payment
                            .execute()
                            .then(function(payment) {
                                // The payment is complete!
                                // You can now show a confirmation message to the customer
                                that.processOrder({
                                    token: '',
                                    paymentData: payment
                                })
                            })
                    }
                },
                '#paypal-button'
            )

            this.paypalInitialized = true
        }
    },
    components: {
        CheckoutHeader,
        CheckoutSummary,
        VueGoogleAutocomplete,
        CheckoutMonitoringPayment
    },
    mounted() {
        /**
         * STRIPE Integration
         */
        // Create an instance of the card Element
        this.card = elements.create('card')

        // Add an instance of the card Element into the `card-element` <div>
        this.card.mount('#card-element')

        this.updateSystem()
    },

    beforeDestroy() {
        this.card.unmount('#card-element')
        this.card.destroy()
    }

}

</script>

<style lang="css"></style>
